import {useState, createContext, useEffect } from "react";
import {Base64} from "../utils/helper.js";

const UserContext = createContext({
	userName : "",
	addUserName : (userName) => {},
	loggedInUserId : "",
	addLoggedInUserId : (loggedInUserId) => {},
	role : "",
	addRole : (role)  => {},
	isAuthenticated : false,
	addIsAuthenticated : (isAuthenticated)  => {},
	lastPingTime : "",
	addLastPingTime : (lastPingTime) => {},
	enabledMFA : 0,
	addEnabledMFA : (enabledMFA) => {},
	lang : "",
	addLang : (lang) => {},
	clearStorage : ()  => {},
	analyticsAccess : [],
	addAnalyticsAccess : (analyticsAccess) => {},
	userCompanyId : 0,
	addUserCompanyId : (userCompanyId) => {},
	userType : "",
	addUserType : (userType) => {},
	companyType : "",
	addCompanyType : (companyType) => {},
	hasDeleteAccess : false,
	addHasDeleteAccess : (hasDeleteAccess) => {},
	});

export function UserContextProvider(props){
	
	const [userName, setUserName] = useState(getUserName());
	const [loggedInUserId, setLoggedInUserId] = useState(getLoggedInUserId());
	const [role, setRole] = useState(getRole());
	const [isAuthenticated, setIsAuthenticated] = useState(getIsAuthenticated());
	const [lastPingTime, setLastPingTime] = useState(getLastPingTime());
	const [enabledMFA, setEnabledMFA] = useState(getEnabledMFA());
	const [lang, setLang] = useState(getLang());
	const [analyticsAccess, setAnalyticsAccess] = useState(getAnalyticsAccess());
	const [userCompanyId, setUserCompanyId] = useState(getUserCompanyId());
	const [userType, setUserType] = useState(getUserType());
	const [companyType, setCompanyType] = useState(getCompanyType());
	const [hasDeleteAccess, setHasDeleteAccess] = useState(getHasDeleteAccess());
	
	const context = {
		userName : userName,
		addUserName :  addUserName,
		loggedInUserId : loggedInUserId,
		addLoggedInUserId : addLoggedInUserId,
		role : role,
		addRole : addRole,
		isAuthenticated : isAuthenticated,
		addIsAuthenticated : addIsAuthenticated,
		lastPingTime : lastPingTime,
		addLastPingTime : addLastPingTime,
		enabledMFA : enabledMFA,
		addEnabledMFA : addEnabledMFA,
		clearStorage : clearStorage,
		lang : lang,
		addLang : addLang,
		analyticsAccess : analyticsAccess,
		addAnalyticsAccess : addAnalyticsAccess,
		userCompanyId : userCompanyId,
		addUserCompanyId : addUserCompanyId,
		userType : userType,
		addUserType : addUserType,
		companyType : companyType,
		addCompanyType : addCompanyType,
		hasDeleteAccess : hasDeleteAccess,
		addHasDeleteAccess: addHasDeleteAccess,
	};
	function clearStorage(){
	  localStorage.clear();
	}
	function getUserName() {
	  let itemKey = Base64.encode('userName');
      const userNameM = localStorage.getItem(itemKey);
      if(userNameM){
        let itemVal = Base64.decode(userNameM);
        return (itemVal? itemVal : "");
      }
      return "";
    }
    function getUserCompanyId() {
	  let itemKey = Base64.encode('userCompanyId');
      const userCompanyIdM = localStorage.getItem(itemKey);
      if(userCompanyIdM){
        let itemVal = Base64.decode(userCompanyIdM);
        return (itemVal? itemVal : 0);
      }
      return "";
    }
    function getAnalyticsAccess() {
	  let itemKey = Base64.encode('analyticsAccess');
      const analyticsAccessM = localStorage.getItem(itemKey);
      if(analyticsAccessM){
        let itemVal = JSON.parse(atob(analyticsAccessM));
        return (itemVal? itemVal : []);
      }
      return [];
    }
   function getLoggedInUserId() {
      let itemKey = Base64.encode('loggedInUserId');
      const loggedInUserIdM = localStorage.getItem(itemKey);
      if(loggedInUserIdM){
        let itemVal = Base64.decode(loggedInUserIdM);
        return (itemVal? itemVal : "");
      }
      return "";
    }
    function getRole() {
      let itemKey = Base64.encode('role');
      const roleM = localStorage.getItem(itemKey);
      if(roleM){
        let itemVal = Base64.decode(roleM);
        return (itemVal? itemVal : "");
      }
      return "";
    }
    
    function getIsAuthenticated() {
      let itemKey = Base64.encode('isAuthenticated');
      const isAuthenticatedM = localStorage.getItem(itemKey);
      if(isAuthenticatedM){
        let itemVal = Base64.decode(isAuthenticatedM);
        return (itemVal? itemVal : false);
      }
      return false;
    }
    
    function getEnabledMFA() {
      let itemKey = Base64.encode('enabledMFA');
      const enabledMFAM = localStorage.getItem(itemKey);
      if(enabledMFAM){
        let itemVal = Base64.decode(enabledMFAM);
        return (itemVal? itemVal : 0);
      }
      return 0;
    }
    function getLastPingTime() {
      let itemKey = Base64.encode('lastPingTime');
      const lastPingTimeM = localStorage.getItem(itemKey);
      if(lastPingTimeM){
        let itemVal = Base64.decode(lastPingTimeM);
        return (itemVal? itemVal : "");
      }
      return "";
    }
    function getLang() {
	  let itemKey = Base64.encode('lang');
      const langM = localStorage.getItem(itemKey);
      if(langM){
        let itemVal = Base64.decode(langM);
        return (itemVal? itemVal : "");
      }
      return "";
    }
    function getUserType() {
	  let itemKey = Base64.encode('userType');
      const userTypeM = localStorage.getItem(itemKey);
      if(userTypeM){
        let itemVal = Base64.decode(userTypeM);
        return (itemVal? itemVal : "");
      }
      return "";
    }
    function getCompanyType() {
	  let itemKey = Base64.encode('companyType');
      const companyTypeM = localStorage.getItem(itemKey);
      if(companyTypeM){
        let itemVal = Base64.decode(companyTypeM);
        return (itemVal? itemVal : "");
      }
      return "";
    }
    function getHasDeleteAccess(){
	  let itemKey = Base64.encode('hasDeleteAccess');
      const hasDeleteAccessM = localStorage.getItem(itemKey);
      if(hasDeleteAccessM){
        let itemVal = Base64.decode(hasDeleteAccessM);
        return (itemVal? itemVal : false);
      }
      return false;
    }
    useEffect(() => {
      if(userName){
        let itemKey = Base64.encode('userName');
        let itemVal = Base64.encode(userName);
        localStorage.setItem(itemKey, itemVal);
      }     
    }, [userName]);
  
    useEffect(() => {
       if(loggedInUserId){
          let itemKey = Base64.encode('loggedInUserId');
          let itemVal = Base64.encode(loggedInUserId);
          localStorage.setItem(itemKey, itemVal);
       } 
    }, [loggedInUserId]);
    
    useEffect(() => {
       if(role){
          let itemKey = Base64.encode('role');
          let itemVal = Base64.encode(role);
          localStorage.setItem(itemKey, itemVal);
       } 
       
    }, [role]);
    
    useEffect(() => {
       if(isAuthenticated !== null){
          let itemKey = Base64.encode('isAuthenticated');
          let itemVal = Base64.encode(""+isAuthenticated);
          localStorage.setItem(itemKey, itemVal);
       } 
       
    }, [isAuthenticated]);
    useEffect(() => {
       if(enabledMFA !== null){
          let itemKey = Base64.encode('enabledMFA');
          let itemVal = Base64.encode(""+enabledMFA);
          localStorage.setItem(itemKey, itemVal);
       } 
       
    }, [enabledMFA]);
    
    useEffect(() => {
       if(lastPingTime){
          let itemKey = Base64.encode('lastPingTime');
          let itemVal = Base64.encode(""+lastPingTime);
          localStorage.setItem(itemKey, itemVal);
       } 
       
    }, [lastPingTime]);
    
    useEffect(() => {
      if(lang){
        let itemKey = Base64.encode('lang');
        let itemVal = Base64.encode(lang);
        localStorage.setItem(itemKey, itemVal);
      }     
    }, [lang]);
    
    useEffect(() => {
       if(analyticsAccess && analyticsAccess.length > 0){
          let itemKey = Base64.encode('analyticsAccess');
          let itemVal = btoa(JSON.stringify(analyticsAccess));
          localStorage.setItem(itemKey, itemVal);
       } 
       
    }, [analyticsAccess]);
    
    useEffect(() => {
       if(userCompanyId !== null){
          let itemKey = Base64.encode('userCompanyId');
          let itemVal = Base64.encode(""+userCompanyId);
          localStorage.setItem(itemKey, itemVal);
       } 
       
    }, [userCompanyId]);
    
    useEffect(() => {
      if(userType){
        let itemKey = Base64.encode('userType');
        let itemVal = Base64.encode(userType);
        localStorage.setItem(itemKey, itemVal);
      }     
    }, [userType]);
    
    useEffect(() => {
      if(companyType){
        let itemKey = Base64.encode('companyType');
        let itemVal = Base64.encode(companyType);
        localStorage.setItem(itemKey, itemVal);
      }     
    }, [companyType]);
    
    useEffect(() => {
      if(hasDeleteAccess){
        let itemKey = Base64.encode('hasDeleteAccess');
        let itemVal = Base64.encode(""+hasDeleteAccess);
        localStorage.setItem(itemKey, itemVal);
      }     
    }, [hasDeleteAccess]);
    
	function addUserName(userName){
		setUserName(userName);
	}
	function addLoggedInUserId(loggedInUserId){
		setLoggedInUserId(loggedInUserId);
	}
	function addRole(role){
		setRole(role);
	}
	function addIsAuthenticated(isAuthenticated){
		setIsAuthenticated(isAuthenticated);
	}
	function addLastPingTime(lastPingTime){
		setLastPingTime(lastPingTime);
	}
	function addEnabledMFA(enabledMFA){
		setEnabledMFA(enabledMFA);
	}
	function addLang(lang){
		setLang(lang);
	}
	function addAnalyticsAccess(analyticsAccess){
		setAnalyticsAccess(analyticsAccess);
	}
	function addUserCompanyId(userCompanyId){
		setUserCompanyId(userCompanyId);
	}
	function addUserType(userType){
		setUserType(userType);
	}
	function addCompanyType(companyType){
		setCompanyType(companyType);
	}
	function addHasDeleteAccess(hasDeleteAccess){
		setHasDeleteAccess(hasDeleteAccess);
	}
	return <UserContext.Provider value ={context}>
	{props.children}
	</UserContext.Provider>;
}

export default UserContext;